import React from 'react';
import { Box, Typography } from '@mui/material';

// Pastel tones shared by every stat card in the Attendance module (Overview, Attendance, Reports, Biometric Mapping).
export const STAT_TONES = {
    green:  { color: '#4FB583', bg: '#E8F7EF' },
    amber:  { color: '#EBA84E', bg: '#FEF3E2' },
    purple: { color: '#9482F2', bg: '#EFECFE' },
    rose:   { color: '#E8808F', bg: '#FDEBEE' },
    blue:   { color: '#5BA4E6', bg: '#E8F3FD' },
};

// One stat card: white icon tile on the left, label / number / detail on the right.
export default function AttStatCard({ label, value, sub, icon: Icon, tone = 'purple' }) {
    const { color, bg } = STAT_TONES[tone] || STAT_TONES.purple;
    return (
        <Box sx={{ p: 1.5, height: '100%', borderRadius: '10px', bgcolor: bg, border: `1px solid ${color}30` }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{
                    width: 38, height: 38, borderRadius: '9px', bgcolor: '#fff', flexShrink: 0,
                    boxShadow: '0 1px 3px rgba(16,24,40,0.08)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <Icon sx={{ color, fontSize: 20 }} />
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontSize: '11px', color, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }} noWrap>
                        {label}
                    </Typography>
                    <Typography sx={{ fontSize: '22px', fontWeight: 800, color: '#0F172A', lineHeight: 1.15, mt: 0.2 }}>
                        {value}
                    </Typography>
                    {sub && (
                        <Typography sx={{ fontSize: '10.5px', color: '#6B7280', fontWeight: 600, mt: 0.3 }} noWrap>
                            {sub}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
}
